export default class Data {
  constructor(page, group) {
    this.page = page;
    this.group = group;
    this.url = `https://afternoon-falls-25894.herokuapp.com/words?page=${page}&group=${group}`;
    this.data = [];
    this.dataTranslation = [];
    this.word = '';
    this.key = 'trnsl.1.1.20200421T164430Z.42831ce7078006a2.7a64d9cc477117a06fe5e359e2d2d33119d6f1d6';
    this.urlYa = `https://translate.yandex.net/api/v1.5/tr.json/translate?key=${this.key}&text=${this.word}&lang=en-ru`;
  }

  async getData() {
    const res = await fetch(this.url);
    const json = await res.json();
    json.forEach((el) => {
      this.data.push(el);
    });
  }


  async getTranslation(word) {
    const url = `https://translate.yandex.net/api/v1.5/tr.json/translate?key=${this.key}&text=${word}&lang=en-ru`;
    const res = await fetch(url);
    const json = await res.json();
    return json.text;
  }

  async gettAllWordsTranslations() {
    await this.getData();
    this.data.forEach((el) => {
      this.getTranslation(el.word);
    });
  }
}
